export type TreeNode = {
  id: string;
  nazwa: string;
  order?: number;
  parentId?: string;
  children: TreeNode[];
};

type InputNode = Omit<TreeNode, 'children'>;

export const buildTree = (items: InputNode[]): TreeNode[] => {
  const itemMap: Record<string, TreeNode> = {};
  const roots: TreeNode[] = [];

  items.forEach((item) => {
    itemMap[item.id] = { ...item, children: [] };
  });

  items.forEach((item) => {
    const currentItem = itemMap[item.id];
    if (item.parentId && itemMap[item.parentId]) {
      itemMap[item.parentId].children.push(currentItem);
    } else {
      roots.push(currentItem);
    }
  });

  const sortChildren = (nodes: TreeNode[]): void => {
    nodes.sort((a, b) => (a.order || 0) - (b.order || 0));
    nodes.forEach((node) => sortChildren(node.children));
  };

  sortChildren(roots);
  return roots;
};
